import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center my-10" }
const _hoisted_2 = { class: "fade-in flex flex-col items-center text-center p-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sending transaction ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Please continue to your wallet to")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("approve your bridge transaction ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_text = _resolveComponent("n-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_spin),
      _createVNode(_component_n_text, { class: "text-[20px] uppercase text-lg font-medium text-white my-5" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_text, { class: "opacity-70 mb-3" }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}